import { HttpParams } from "@angular/common/http";

export class HttpParamsUtil {
  protected toHttpParams<T>(params: { [param in keyof T]: T[param] | undefined | null }): HttpParams {
    let httpParams = new HttpParams();
    Object.keys(params).forEach((key: string) => {
      const value = params[key as keyof T];
      if (value !== null && value !== undefined) {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return httpParams;
  }
}
